import "./App.css";
import Icons from "./components/Icons";

// Import Pages
import Home from "./pages/HomePage";

function App() {
  return (
    <div className="App">
      <Icons />
      <Home />
    </div>
  );
}

export default App;
